import { useState, FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../services/api';

export default function ForgotPasswordPage() {
  const [email, setEmail]     = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent]       = useState(false);
  const [error, setError]     = useState('');

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await api.auth.forgotPassword({ email });
      setSent(true);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Ismeretlen hiba.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={{ minHeight: '100vh', background: 'var(--background)', display: 'flex', flexDirection: 'column' }}>

      {/* ── Hero header ── */}
      <div style={{
        background: 'linear-gradient(135deg, var(--primary) 0%, #064944 58%, var(--secondary) 150%)',
        padding: '32px 40px', display: 'flex', alignItems: 'center', gap: 18,
      }}>
        <img src="/logo_gymsmkik.svg" style={{ height: 40, width: 'auto' }} alt="GYMSMKIK" />
        <div style={{ borderLeft: '1px solid rgba(255,255,255,.3)', paddingLeft: 18 }}>
          <div style={{ fontWeight: 700, fontSize: 16, color: '#fff', lineHeight: 1.2 }}>
            Védjegy Digitalizációs Platform
          </div>
          <div style={{ fontSize: 12, color: 'rgba(255,255,255,.72)', marginTop: 2 }}>
            GYMSM KIK, Védjegy pályázati portál
          </div>
        </div>
      </div>

      {/* ── Card ── */}
      <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '48px 20px' }}>
        <div style={{
          background: '#fff', border: '1px solid var(--border)',
          borderRadius: 'var(--radius-lg)', padding: '44px 48px',
          boxShadow: 'var(--shadow-md)', width: '100%', maxWidth: 440,
        }}>
          {sent ? (
            /* ── Sikeres küldés ── */
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: 48, marginBottom: 20 }}>✉️</div>
              <h1 style={{ margin: '0 0 12px', fontSize: 22, fontWeight: 700, color: 'var(--primary)' }}>
                Email elküldve
              </h1>
              <p style={{ margin: '0 0 28px', fontSize: 14, color: 'var(--muted-foreground)', lineHeight: 1.6 }}>
                Ha az e-mail cím regisztrálva van, hamarosan megérkezik a visszaállítási link.
                Kérjük, ellenőrizze a spam mappáját is.
              </p>
              <Link to="/login" className="btn btn-primary" style={{ display: 'inline-block', textDecoration: 'none' }}>
                Vissza a bejelentkezéshez
              </Link>
            </div>
          ) : (
            /* ── Űrlap ── */
            <>
              <div style={{ marginBottom: 32 }}>
                <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: '.12em', textTransform: 'uppercase', color: 'var(--secondary-foreground)', marginBottom: 8 }}>
                  JELSZÓ VISSZAÁLLÍTÁS
                </div>
                <h1 style={{ margin: 0, fontSize: 26, fontWeight: 700, color: 'var(--primary)' }}>
                  Elfelejtett jelszó
                </h1>
                <p style={{ margin: '8px 0 0', fontSize: 14, color: 'var(--muted-foreground)' }}>
                  Adja meg regisztrált e-mail címét, és küldünk egy visszaállítási linket.
                </p>
              </div>

              {error && (
                <div className="alert alert-destructive" style={{ marginBottom: 20 }}>
                  <span>⚠</span>
                  <div><strong>Hiba</strong><p>{error}</p></div>
                </div>
              )}

              <form onSubmit={(e) => { void handleSubmit(e); }}>
                <div className="field" style={{ marginBottom: 24 }}>
                  <label htmlFor="email">E-mail cím <span className="req">*</span></label>
                  <input
                    id="email" type="email" autoComplete="email"
                    value={email} onChange={(e) => setEmail(e.target.value)}
                    placeholder="pelda@ceg.hu" required
                  />
                </div>

                <button
                  type="submit"
                  className="btn btn-primary"
                  style={{ width: '100%', marginBottom: 16 }}
                  disabled={loading}
                >
                  {loading ? 'Küldés…' : 'Visszaállítási link küldése →'}
                </button>
              </form>

              <div style={{ textAlign: 'center', fontSize: 14, color: 'var(--muted-foreground)' }}>
                <Link to="/login" style={{ color: 'var(--primary)', fontWeight: 600, textDecoration: 'none' }}>
                  ← Vissza a bejelentkezéshez
                </Link>
              </div>
            </>
          )}
        </div>
      </div>

      <div style={{ padding: '16px 40px', fontSize: 12, color: 'var(--muted-foreground)', textAlign: 'center' }}>
        © {new Date().getFullYear()} GYMSMKIK — Győr-Moson-Sopron Vármegyei Kereskedelmi és Iparkamara
      </div>
    </div>
  );
}
